import type { ShipmentEventApi } from "@services/shipments/types";

export const exportShipmentEventsToCSV = (
  events: ShipmentEventApi[],
  shipmentId: string
) => {
  if (events.length === 0) {
    return;
  }

  // Create CSV headers
  const csvHeaders = [
    "Date",
    "From",
    "To",
    "Subject",
    "Description",
    "Context",
    "EmailId",
  ];

  // Generate CSV rows
  const csvRows = events.map((event) => {
    // Format date as yyyy/mm/dd hh:mm
    const formatDate = (date: Date | string | undefined) => {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${year}/${month}/${day} ${hours}:${minutes}`;
    };

    // Join email addresses with semicolons
    const fromEmails = event.emailFrom?.join("; ") || "";
    const toEmails = event.emailTo?.join("; ") || "";

    return [
      formatDate(event.date),
      fromEmails,
      toEmails,
      event.emailSubject || "",
      event.description || "",
      event.context || "",
      event.emailId || "",
    ];
  });

  // Create CSV content
  const csvContent = [
    csvHeaders.join(","),
    ...csvRows.map((row) =>
      row
        .map((field) => {
          // Escape quotes in CSV
          const escaped = field.replace(/"/g, '""');
          // Wrap fields containing commas, quotes, or line breaks in quotes
          if (escaped.includes(",") || escaped.includes('"') || escaped.includes("\n")) {
            return `"${escaped}"`;
          }
          return escaped;
        })
        .join(",")
    ),
  ].join("\n");

  // Create and download the file
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);

    // Generate filename with timestamp
    const timestamp = new Date().toISOString().split("T")[0];
    link.setAttribute(
      "download",
      `shipment_events_${shipmentId}_${timestamp}.csv`
    );

    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};
